var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signs"},[(_vm.singList.length > 1)?_c('span',[_vm._v(" Луна в созвездиях "+_vm._s(_vm.singList[0])+" и "+_vm._s(_vm.singList[1])+" ")]):_c('span',[_vm._v(" Луна в созвездии "+_vm._s(_vm.singList[0])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }